import {
    type FC
} from "react";
import type {
    ZoomableImageProps
} from "./type";
import stylesheet from "./stylesheet";
import {
    useDebouncedDimensions
} from "../../../../../utils";
import Animated, {
    useSharedValue,
    useAnimatedStyle,
    withTiming
} from "react-native-reanimated";
import {
    Gesture,
    GestureDetector
} from "react-native-gesture-handler";

const ZoomableImage: FC<ZoomableImageProps> = ({
    uri
}) => {
    const scale = useSharedValue<number>(1);
    const savedScale = useSharedValue<number>(1);
    const {
        actualWindowWidth
    } = useDebouncedDimensions();

    const pinchGesture = Gesture.Pinch()
        .onUpdate((e) => {
            // Parmaklar açıldıkça resmi büyüt
            scale.value = savedScale.value * e.scale;
        })
        .onEnd(() => {
            if (scale.value < 1) {
                scale.value = withTiming(1);
                savedScale.value = 1;
            } else {
                savedScale.value = scale.value;
            }
        });

    const animatedStyle = useAnimatedStyle(() => ({
        transform: [
            {
                scale: scale.value
            }
        ]
    }));

    return <GestureDetector
        gesture={pinchGesture}
    >
        <Animated.View
            style={[
                stylesheet.modalImageContainer,
                {
                    width: actualWindowWidth
                }
            ]}
        >
            <Animated.Image
                source={{
                    uri: uri
                }}
                style={[
                    stylesheet.modalImage,
                    animatedStyle
                ]}
                resizeMode="contain"
            />
        </Animated.View>
    </GestureDetector>;
};
export default ZoomableImage;
